module.exports = __webpack_public_path__ + "static/media/like_filled.28628c12.svg";